module.exports = __webpack_public_path__ + "static/media/Base_Build_Up_BoundBase.fc2edeab.pdf";